import { sendInfrastructureAnalytics } from '../utils';

export const trackInfrastructurePinClick = (infrastructureType: string) =>
  sendInfrastructureAnalytics({
    action: 'click_pin_infra',
    infrastructureType,
  });
